// Fixed lists from the Expenses API.
export const PAYMENT_MODES = ['Cash', 'Bank Transfer', 'UPI', 'Card', 'Cheque'];
export const PAYMENT_TYPES = ['Prepaid', 'Postpaid'];

// The payment API has no shoot field, so the shoot a payment is for rides in the notes as
// "[Shoot name] notes" and is split back out when payments are read.
export const packShoot = (shoot, notes) => [shoot ? `[${shoot.trim()}]` : '', notes || ''].filter(Boolean).join(' ');
export const unpackShoot = (raw) => {
    const m = /^\[([^\]]+)\]\s*([\s\S]*)$/.exec(raw || '');
    return m ? { shoot: m[1], notes: m[2] } : { shoot: '', notes: raw || '' };
};
